
export default {
  name: 'ScrollObserver',
  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    observer: null,
  }),
  mounted() {
    const options = this.options || { threshold: 1 };
    this.observer = new IntersectionObserver(([entry]) => {
      if (entry && entry.isIntersecting) {
        this.$emit('intersection');
      }
    }, options);
    this.observer.observe(this.$el);
  },
  destroyed() {
    this.observer.disconnect();
  },
};
